import React from 'react';
import { contactEmail, facebookPageUrl, instagramPageUrl, spotifyArtistUrl, youtubeMusicUrl } from '../data/siteData';

const Footer = () => {
  return (
    <footer className="footer" data-testid="site-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title" data-testid="footer-brand-title">STATÌC RÎFT</h3>
            <p className="footer-text">Full Gauge Records</p>
            <p className="footer-text text-electric-blue">Statìc Oäths out May 29</p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <div className="footer-links">
              <a href="#about" className="footer-link" data-testid="footer-about-link">About</a>
              <a href="#music" className="footer-link" data-testid="footer-music-link">Music</a>
              <a href="#merch" className="footer-link" data-testid="footer-merch-link">Merch</a>
              <a href="#contact" className="footer-link" data-testid="footer-contact-link">Contact</a>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Connect</h4>
            <div className="footer-links">
              <a href={spotifyArtistUrl} target="_blank" rel="noopener noreferrer" className="footer-link" data-testid="footer-spotify-link">
                Spotify
              </a>
              <a href={instagramPageUrl} target="_blank" rel="noopener noreferrer" className="footer-link" data-testid="footer-instagram-link">Instagram</a>
              <a href={facebookPageUrl} target="_blank" rel="noopener noreferrer" className="footer-link" data-testid="footer-facebook-link">Facebook</a>
              <a href={youtubeMusicUrl} target="_blank" rel="noopener noreferrer" className="footer-link" data-testid="footer-youtube-music-link">YouTube Music</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} Statìc Rîft / Full Gauge Records. All rights reserved.
          </p>
          <p className="footer-artist mt-2">
            Chase Tucker
          </p>
          <p className="footer-email mt-2">
            Official Contact: <a href={`mailto:${contactEmail}`} className="footer-email-link" data-testid="footer-email-link">{contactEmail}</a>
          </p>
          <p className="footer-domain mt-2 text-electric-blue">
            staticriftfullgaugerecords.com
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;